import apiClient from '../index';

export interface CreateSessionRequest {
  content: string;
  role: 'user';
}

export interface SendMessageRequest {
  chat_id: string;
  content: string;
  role: 'user';
}

export interface SessionResponse {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
}

export interface MessageResponse {
  id: string;
  chat_id: string;
  content: string;
  created_at: string;
  role: 'user' | 'assistant';
  references?: {
    ref_num: number;
    id: string;
    title: string;
    url: string;
    chunk_index: number;
  }[];
  tokens_left: number;
  tokens_total: number;
}

export const chatApi = {
  // Session operations
  createSession: (data: CreateSessionRequest) =>
    apiClient.post<SessionResponse>('/api/chat/sessions', data),

  getSessions: () =>
    apiClient.get<SessionResponse[]>('/api/chat/sessions'),

  getSession: (sessionId: string) =>
    apiClient.get<SessionResponse>(`/api/chat/sessions/${sessionId}`),

  deleteSession: (sessionId: string) =>
    apiClient.delete<SessionResponse>(`/api/chat/sessions/${sessionId}`),

  // Message operations
  getMessages: (sessionId: string) =>
    apiClient.get<MessageResponse[]>(`/api/chat/sessions/${sessionId}/messages`),

  sendMessage: (sessionId: string, data: SendMessageRequest) =>
    apiClient.post<MessageResponse>(`/api/chat/sessions/${sessionId}/messages`, data),

  // Get assistant response
  getAssistantMessage: (sessionId: string) =>
    apiClient.get<MessageResponse>(`/api/chat/sessions/${sessionId}/ask_zven`),
};